import { render } from "./WalletsView.vue?vue&type=template&id=12b62c36"
import script from "./WalletsView.vue?vue&type=script&lang=js"
export * from "./WalletsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__